// extracted by mini-css-extract-plugin
module.exports = {"main":"App_main__3ZkGI","content":"App_content__3La4L","blocks":"App_blocks__mms9t","block":"App_block__3ooQu","socials":"App_socials__2W9jC"};